module.exports = __webpack_public_path__ + "static/media/male.287d0809.png";